import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { useState, useEffect } from 'react'
import useLoggedIn from '@src/auth/hooks/auth.hook'

function useLoginDetails(): {
  isLoggedIn: boolean
  customerEmail: string | undefined
} {
  const [customerEmail, setCustomerEmail] = useState<string | undefined>('')
  const isLoggedIn = useLoggedIn()

  useEffect(() => {
    const customerEmailFromLS = isLoggedIn ? AuthUtil.getUser().email : ''
    setCustomerEmail(customerEmailFromLS)
  }, [isLoggedIn])

  return {
    isLoggedIn,
    customerEmail,
  }
}

export default useLoginDetails
